import {
    getData,
    postData,
} from './Services'

export const postAuthLogin= async (body) => {
    const res = await postData('/auth/loginPanel', body, true)
    return res
}

export const getUserInfo= async (body) => {
    const res = await getData('/auth/me', body, true)
    return res
}

export const getMe= async (body) => {
    const res = await getData('/auth/me', body, true)
    return res
}